// userGroup
export default {
    RBI_Administrator: "RBI_administrator",
    RBI_End_User: "RBI_enduser",
    Franchisee: "Franchise"
}